import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as loginSelectors from './..../../../../../root-store/login-store/login.selector';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Validators } from 'ngx-editor';
import { BsFileUploadNewComponent } from '@app/modules/bs-file-upload-new/bs-file-upload-new.component';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { FileUploadService } from '@app/shared/services/file-upload/file-upload.service';
import { UserConnectionService, UserService } from '@app/shared/services';
import { MatMenuTrigger } from '@angular/material/menu';
import { InviteService } from '.././../../shared/services/invite/invite.service';
import { LoginStoreEffects } from '../../../root-store/login-store/effects';
import { UserTypeEnum } from '../../../enum/UserTypeEnum';
import { ConnectRelationshipDialogComponent } from '../connect-relationship-dialog/connect-relationship-dialog.component';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'app-connection-modal',
  templateUrl: './connection-modal.component.html',
})
export class ConnectionModalComponent implements OnInit, OnDestroy {
  @ViewChild('menuTrigger') menu: MatMenuTrigger;
  @ViewChild('connectRelationshipDialog') connectRelationshipDialog: ConnectRelationshipDialogComponent;
  user$;
  connectionForm: FormGroup;
  format = null;
  imageChangedEvent = '';
  subscription = new Subscription();
  isPendingImg = false;
  pendingImgSrc = '';
  id = '';
  hideText = undefined;
  relationshipId;
  relationshipType;
  connection_relationship_data: any = {};
  selectedRelationship = {
    id: 68,
    name: 'Client',
  };
  isImpersonating = true;
  hasGuardianAccess = false;
  @Output() connectionCreated = new EventEmitter();
  constructor(
    private store: Store,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private fileUploadService: FileUploadService,
    private userService: UserService,
    private graphqlService: UserConnectionService,
    private loginService: LoginStoreEffects,
    private inviteService: InviteService
  ) {}
  ngOnInit(): void {
    this.user$ = this.store.select(loginSelectors.getCurrentUserDetailsAll);
    this.subscription.add(
      this.store.select(loginSelectors.getCurrentUserDetailsAll).subscribe((res) => {
        this.id = res?.id;
      })
    );
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state.data != null && state?.data?.id != null && state?.data?.id != undefined) {
          const user = state.data;
          if (user?.userLicense?.license_type == 'family' || user.user_type == UserTypeEnum.Professional) {
            this.hasGuardianAccess = true;
            this.connectionForm = this.fb.group({
              first_name: ['', [Validators.required, noWhitespaceValidator()]],
              last_name: ['', [Validators.required, noWhitespaceValidator()]],
              dateOfBirth: ['', [Validators.required]],
              relationship_type: ['', [Validators.required]],
            });
          } else {
            this.hasGuardianAccess = false;
            this.connectionForm = this.fb.group({
              full_name: ['', [Validators.required, noWhitespaceValidator()]],
              email: ['', [Validators.required, noWhitespaceValidator()]],
              relationship_type: ['', [Validators.required]],
              dateOfBirth: ['', [Validators.required]],
            });
          }
        }
      })
    );
  }
  fileChangeEvent(event: any): void {
    const file = event.target.files && event.target.files[0];
    let extension = file.name.split('.').pop();
    if (file) {
      if (file.type.indexOf('image') > -1) {
        this.format = 'image';
        this.imageChangedEvent = event;
        this.cd.markForCheck();
      } else if (file.type.indexOf('video') > -1) {
        this.format = 'video';
        this.toastr.error('Invalid image type.');
      }

      if (file.type.indexOf('image') > -1) {
        let modalRef2;

        modalRef2 = this.dialog.open(BsFileUploadNewComponent, {
          data: {
            videoMimeType: file.type,
            format: this.format,
            type: 'guardian',
            title: 'Upload Guardian Profile Picture',
            image: 'profile',
            guardianId: 'noId',
            imageChangedEvent: this.imageChangedEvent,
            extension,
          },
          autoFocus: false,
          panelClass: 'full-window-dialog-2',
        });

        this.subscription.add(
          modalRef2.afterClosed().subscribe(async (upload_promise: any) => {
            const res = await upload_promise;
            if (res !== 'noId') {
              //  this.getGuardianUserDetails(this.connectionForm.controls['id'].value);
            } else {
              this.isPendingImg = true;
              const { file } = JSON.parse(localStorage.getItem('guardianImageToBeUploaded'));
              this.pendingImgSrc = file;
              this.toastr.success(`Image added`);
              this.cd.detectChanges();
            }
          })
        );
      }
    }
  }
  openImageUploadDialog() {}
  submitForm() {
    this.createGuardianUser();
  }
  public doSomething(data: any): void {
    this.relationshipId = data.id;
    this.relationshipType = data.name;
    this.connectionForm.controls['relationship_type'].setValue(data.name);
    this.cd.detectChanges();
  }
  async addGuardianPic(id) {
    const file = JSON.parse(localStorage.getItem('guardianImageToBeUploaded'));
    const fd = { ...file, user_id: id };
    this.subscription.add(
      this.fileUploadService.guardianImage(fd).subscribe((res) => {
        this.pendingImgSrc = null;
        localStorage.removeItem('guardianImageToBeUploaded');
        this.cd.detectChanges();
      })
    );
  }
  createGuardianUser() {
    const gPayload = {
      ...this.connectionForm.value,
      guardian_user_id: this.id,
    };
    if (this.connectionForm.valid) {
      if (this.hasGuardianAccess) {
        this.subscription.add(
          this.userService.addGuardianUser({ ...gPayload, relationship_name: gPayload.relationship_type }).subscribe((res) => {
            if (res?.guidance_status) {
              const payload = {
                from_user_id: this.id,
                relationship_id: this.relationshipId,
                requested_user_id: res?.id,
                status: 'approved',
              };
              this.connectUser(payload);
              if (this.isPendingImg == true) {
                this.addGuardianPic(res.id).then(() => {
                  setTimeout(() => {}, 1500);
                });
              } else {
              }
              this.connectRelationshipDialog.clearData();
              this.connectionCreated.emit(res);
            }
            this.cd.detectChanges();
          })
        );
      } else {
        const createUserData = {
          ...this.connectionForm.value,
          relationship_id: this.relationshipId,
          relationship_name: this.connectionForm.controls['relationship_type'].value,
          to_name: this.connectionForm.controls['full_name'].value,
          user_id: gPayload.guardian_user_id,
          user_type: '',
        };
        this.subscription.add(
          this.inviteService.createInvite(createUserData).subscribe((res) => {
            if (res?.guidance_status) {
              const payload = {
                from_user_id: this.id,
                relationship_id: this.relationshipId,
                requested_user_id: res?.id,
                status: 'approved',
              };
              this.connectUser(payload);
              if (this.isPendingImg == true) {
                this.addGuardianPic(res.id).then(() => {
                  setTimeout(() => {}, 1500);
                });
              } else {
              }
              this.connectRelationshipDialog.clearData();
              this.connectionCreated.emit(res);
            }
            this.cd.detectChanges();
          })
        );
      }
    }
  }
  connectUser(payload) {
    this.subscription.add(
      this.graphqlService.connectToUser(payload).subscribe(async (res) => {
        const p = await res;
        res.finally(() => {
          this.subscription.add(this.graphqlService.getConnections().subscribe((data) => {}));
          this.connectionForm.reset();
          this.menu.closeMenu();
          this.toastr.success('New family account created');
        });
        if (p?.connection_status == 'pending') {
          this.connectionForm.reset();
          this.menu.closeMenu();
          this.toastr.success('New family account created');
        }
      })
    );
  }
  onMenuClosed() {
    this.relationshipId = null;
    this.relationshipType = null;
  }
  relationshipIdChanged(id) {}
  handleTabFix(event: any) {
    if (event.key === 'Tab' || event.code === 'Tab') {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isWhitespace = (control.value || '').trim().length === 0;
    return isWhitespace ? { whitespace: true } : null;
  };
}
